import React, { Component } from 'react';
import { colors } from '@peachjar/components';
import TaskBoxAction from './TaskBoxAction';
import TaskBoxStatus from './TaskBoxStatus';
import { css } from 'react-emotion';

// remove default portion later
const { platinum, prussian } = colors;

const styles = {
  box: css({
    borderRadius: '0.25rem',
    backgroundColor: platinum,
  }),
  title: css({
    color: prussian,
  }),
};

class TaskBox extends Component {
  static Action = TaskBoxAction;
  static Status = TaskBoxStatus;

  render() {
    const { title, children } = this.props;

    return (
      <div
        className={`layout-row layout-align-space-between-center pj-font-size-02 pj-padding--base ${
          styles.box
        }`}
      >
        <span
          className={`flex-33 pj-font-weight-bold pj-font-family-thick ${
            styles.title
          }`}
        >
          {title}
        </span>
        {children}
      </div>
    );
  }
}

export default TaskBox;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/TaskBox.jsx